import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="invoice-subscription-form"
export default class extends Controller {
	static targets = ["customDateContainer", "customDateTemplate", "select"];

	connect() {
		this.toggleCustomDate({ target: this.selectTarget });
	}

	toggleCustomDate(event) {
		if (event.target.value === "custom") {
			this.customDateContainerTarget.innerHTML =
				this.customDateTemplateTarget.innerHTML;
			this.customDateContainerTarget.style.display = "block";
		} else {
			this.customDateContainerTarget.innerHTML = "";
			this.customDateContainerTarget.style.display = "none";
		}
	}
}
